import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import {
  appStore,
  orgStore,
  permissionStore,
  saveTeamStore,
  teamApiStore,
  teamStore,
} from "@/hooks";
import { navigateTo, Routes } from "@/router";
import { FlexBox, TextButton } from "@/components/common";


/**
 * Displays a team's actions.
 */
const __default__ = {
  name: "TeamButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const team = computed(() => teamStore.team);

const displayEdit = computed(() =>
  permissionStore.isAllowed("team.edit", teamStore.team)
);
const displayDelete = computed(() =>
  permissionStore.isAllowed("team.delete", teamStore.team)
);

/**
 * Opens the team editor.
 */
function handleEdit() {
  saveTeamStore.resetTeam(team.value);
  appStore.open("saveTeam");
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    t: "2",
    class: "settings-buttons",
    wrap: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        label: "Organization",
        icon: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navigateTo)(_unref(Routes).ORG)))
      }),
      _createVNode(_component_q_btn_dropdown, {
        flat: "",
        "auto-close": "",
        label: "Teams"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            column: "",
            align: "center",
            x: "2",
            y: "2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgStore).org.teams, (t) => {
                return (_openBlock(), _createBlock(_unref(TextButton), {
                  key: t.id,
                  text: "",
                  label: t.name,
                  onClick: ($event: any) => (_unref(teamApiStore).currentTeam = t)
                }, null, 8, ["label", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (displayEdit.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Edit",
            icon: "edit",
            "data-cy": "button-team-edit",
            onClick: handleEdit
          }))
        : _createCommentVNode("", true),
      (displayDelete.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 1,
            text: "",
            label: "Delete",
            icon: "delete",
            "data-cy": "button-team-delete",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(teamApiStore).handleDelete(team.value)))
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})